import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import ProfileNav from './ProfileNav';
import { Button } from '@mui/material';
import SidebarHeader from './SidebarHeader';
import SidebarMenu from './SidebarMenu';
import SidebarFooter from './SidebarFooter';

const Navigation = ({
    sidebarFooter
}) => {
    const [sidebarToggle, setSidebarToggle] = useState(false);
    const hamburgerRef = useRef(null);
    const sidebarNavRef = useRef(null);

    useEffect(() => {
        if (!sidebarToggle) {
            return undefined;
        }
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setSidebarToggle(false);
                if (hamburgerRef.current) {
                    hamburgerRef.current.focus();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [sidebarToggle]);

    // The sidebar is only ever hidden off-screen (not unmounted/display:none),
    // so while closed its contents must be excluded from the tab order and the
    // accessibility tree. `inert` is set imperatively via a ref rather than as
    // a JSX prop for broad browser compatibility; unsupported browsers simply
    // keep the previous (still-focusable) behavior as a harmless fallback.
    useEffect(() => {
        if (sidebarNavRef.current) {
            sidebarNavRef.current.inert = !sidebarToggle;
        }
    }, [sidebarToggle]);

    return <>
        <div className='left-nav-btn'>
            <Button
                ref={hamburgerRef}
                aria-label="Toggle navigation menu"
                aria-expanded={sidebarToggle}
                className={clsx(
                    'navbar-toggler hamburger hamburger--elastic ',
                    { 'is-active': sidebarToggle }
                )}
                onClick={() => setSidebarToggle(!sidebarToggle)}>
                <span className="hamburger-box" aria-hidden="true">
                    <span className="hamburger-inner" aria-hidden="true" />
                </span>
            </Button>
        </div>
        <div
            className={clsx('app-wrapper', {
                'header-drawer-open': sidebarToggle,
                'app-sidebar-collapsed': sidebarToggle,
                'app-sidebar-mobile-open': sidebarToggle,
                'app-sidebar-fixed': false,
                'app-header-fixed': true,
                'app-footer-fixed': true,
                'search-wrapper-open': false
            })}>
            <div>
                <nav className="app-sidebar" aria-label="Main navigation" ref={sidebarNavRef}>
                    <SidebarHeader sidebarToggle={sidebarToggle} onSidebarToggle={() => setSidebarToggle(!sidebarToggle)} />
                    <div className="app-sidebar--content">
                        <SidebarMenu onSidebarToggle={() => setSidebarToggle(!sidebarToggle)} />
                    </div>
                    {sidebarFooter && <SidebarFooter />}
                </nav>
                <div
                    onClick={() => setSidebarToggle(!sidebarToggle)}
                    aria-hidden="true"
                    className={clsx('app-sidebar-overlay', {
                        'is-active': sidebarToggle
                    })}
                />
            </div>
        </div>
    </>;
}

export default Navigation;